import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import { ON_CLASSRANKED } from './consts/index'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { env } from './env'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import * as Sentry from '@sentry/react'

const SENTRY_DSN = 'https://b2a7c4f071522651fcca59ebf18df666@o4510307966713856.ingest.us.sentry.io/4510382342930433'

if (ON_CLASSRANKED) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: env.REACT_APP_AWS_ENVIRONMENT,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false
      })
    ],
    replaysSessionSampleRate: 0.8,
    replaysOnErrorSampleRate: 1.0
  })
}

const router = createBrowserRouter([
  {
    path: '/*',
    element: <App />
  }
])

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
